const styleOptions = {};

const initMap = {
	muromachi: function(){
		var latlng = new google.maps.LatLng(34.997196, 135.757888);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapHead"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(34.997196, 135.757888),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function(){
			infowin.open(map, marker);
		});
	},
	tokyo: function(){
		var latlng = new google.maps.LatLng(35.694393,139.693855);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapTokyo"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(35.694393,139.693855),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function(){
			infowin.open(map, marker);
		});
	},
	jujo: function(){
		var latlng = new google.maps.LatLng(34.97043908521924, 135.74948180099773);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapJujo"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(34.97043908521924, 135.74948180099773),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function(){
			infowin.open(map, marker);
		});
	},
	akezu: function(){
		var latlng = new google.maps.LatLng(34.998161, 135.7599508);
		var opts = {
			zoom: 17,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			center: latlng
		};

		var map = new google.maps.Map(document.getElementById("mapAkezu"), opts);
		var markerOpts = {
			position: new google.maps.LatLng(34.998161, 135.76048),
			map: map,
			title: "marker"
		};
		var marker = new google.maps.Marker(markerOpts);

		var sampleType = new google.maps.StyledMapType(styleOptions);
		map.mapTypes.set('sample', sampleType);
		map.setMapTypeId('sample');

		google.maps.event.addListener(marker, 'click', function(){
			infowin.open(map, marker);
		});
	}
}

module.exports = initMap;




// WEBPACK FOOTER //
// ./es2015/_access.js